import { Controller } from "@hotwired/stimulus";

// A row of "In this note" with sub-notes of its own (LI-373). Bootstrap's collapse opens and closes
// them and flips the chevron's aria-expanded; this swaps its label between expand and collapse.
// A nested row's collapse events bubble up through this one, so only this row's own count.
export default class extends Controller {
  toggled(event) {
    const children = this.element.querySelector(":scope > .notes-subnote__children");
    if (event.target !== children) return;

    const button = this.element.querySelector(":scope > .notes-subnote > .notes-subnote__toggle");
    button.setAttribute("aria-label", event.type.startsWith("show") ? button.dataset.collapseLabel : button.dataset.expandLabel);
  }
}
